const initState = {
    templates: [],
    template: {},
    groups: [],
    contacts: [],
    statistics: {},
    progress_status: false,
    loading: true,
    error: false,
    loading_BC: false,
    error_BC: false,  
  }
  
  const reducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_TEMPLATES':
        return {...state, templates: action.payload}
      case 'SET_TEMPLATE':
        return {...state, template: action.payload}
      case 'SET_GROUPS':
        return {...state, groups: action.payload}
      case 'SET_CONTACTS':
        return {...state, contacts: action.payload}
      case 'SET_BC_STATS':
        return {...state, statistics: action.payload}
      case 'SET_PROGRESS_STATUS':
        return {...state, progress_status: action.payload}
      case 'SET_LOADING_BC': 
        return {...state, loading_BC: action.payload}
      case 'SET_ERROR_BC':
        return {...state, error_BC: action.payload}    
      default: 
        return state
    }
  }
  
  export default reducer